(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["realsee-point-cloud"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('point-cloud-vr')) {
  customElements.define('point-cloud-vr', class extends HTMLElement {
    connectedCallback() {
      this.onVisibility = () => {
        if (!document.hidden && this.inView) this.ensureFrame();
      };
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        if (this.inView) this.ensureFrame();
      });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('pageshow', this.onVisibility);
      this.checkTimer = setInterval(() => {
        if (!document.hidden && this.inView) this.ensureFrame();
      }, 3000);
    }
    ensureFrame() {
      if (!this.isConnected || document.hidden) return;
      const existing = this.querySelector('iframe');
      if (existing) {
        // A moved iframe can retain its src while its browsing context is reset.
        try {
          if (existing.contentWindow.location.href !== 'about:blank') return;
        } catch (_) {
          return; // The cross-origin VR document has taken over.
        }
        if (Date.now() - this.mountedAt < 15000) return;
      }
      const frame = document.createElement('iframe');
      frame.title = this.dataset.title;
      frame.loading = 'eager';
      frame.allow = 'fullscreen; xr-spatial-tracking; accelerometer; gyroscope';
      frame.allowFullscreen = true;
      this.mountedAt = Date.now();
      this.replaceChildren(frame);
      frame.src = this.dataset.src;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearInterval(this.checkTimer);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('pageshow', this.onVisibility);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const main = document.querySelector('main');
    const firstSection = main ? main.querySelector('section, x-slideshow') : null;
    const firstElement = firstSection?.tagName === 'SECTION' ? firstSection : firstSection?.closest('section');
    const slideshowInMain = firstElement ? firstElement.querySelector('slideshow-carousel') : null;
    if (slideshowInMain) {
      const header = document.querySelector('.header');
      const slide = slideshowInMain.querySelector('.slideshow__slide.is-selected');
      const headerType = slide ? slide.getAttribute('data-header-type') : null;
      if (headerType && header) {
        header.classList.remove('header--dark', 'header--light');
        header.classList.add('header--' + headerType);
      }
      slideshowInMain.addEventListener('carousel:select', (event) => {
        
        const slide = slideshowInMain.querySelector('.slideshow__slide.is-selected');
        const headerType = slide ? slide.getAttribute('data-header-type') : null;
        if (headerType && header) {
          header.classList.remove('header--dark', 'header--light');
          header.classList.add('header--' + headerType);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-camera-introduction"] && !Shopify.designMode) return;
  try {
    
  class YGCameraIntroduction extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.items = [];
      this.autoPlayInterval = null;
      this.duration = 10000; // 10 seconds
      this.init();
    }

    init() {
      this.items = Array.from(this.querySelectorAll('.yg-introduction-item'));
      this.backgroundItems = Array.from(this.closest('.section').querySelectorAll('.yg-background-item'));
      if (this.items.length === 0) return;

      const prevButton = this.querySelector('.yg-prev-button');
      const nextButton = this.querySelector('.yg-next-button');
      const dots = this.querySelectorAll('.yg-dot');
      const progressBars = this.querySelectorAll('.yg-progress-bar-item');

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          this.stopAutoPlay();
          this.prev();
          this.startAutoPlay();
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', () => {
          this.stopAutoPlay();
          this.next();
          this.startAutoPlay();
        });
      }
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.stopAutoPlay();
          this.goTo(index);
          this.startAutoPlay();
        });
      });
      progressBars.forEach((bar, index) => {
        bar.addEventListener('click', () => {
          this.stopAutoPlay();
          this.goTo(index);
          this.startAutoPlay();
        });
      });

      // Start auto play
      this.startAutoPlay();
    }

    startAutoPlay() {
      this.stopAutoPlay();
      this.autoPlayInterval = setInterval(() => {
        this.next();
      }, this.duration);
    }

    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    }

    infoGoTo(index) {
      // Update items
      this.items[this.currentIndex].classList.remove('active');
      this.items[index].classList.add('active');

      // Update progress bars
      const progressBars = this.querySelectorAll('.yg-progress-bar-item');
      progressBars[this.currentIndex].classList.remove('active');
      progressBars[index].classList.add('active');

      // Update mobile introduction items
      const mobileItems = this.querySelectorAll('.yg-mobile-introduction-item');
      if (mobileItems.length > 0) {
        mobileItems[this.currentIndex].classList.remove('active');
        mobileItems[index].classList.add('active');
      }
    }

    goTo(index, direction) {
      if (index < 0) {
        index = this.items.length - 1;
      } else if (index >= this.items.length) {
        index = 0;
      }

      let videoIndex;
      if(direction == 'next') {
        videoIndex = (index - 1 + this.items.length) % this.items.length;
      } else {
        videoIndex = index;
      }
      // 获取当前项目和视频容器
      const currentItem = this.backgroundItems[videoIndex];
      const videoContainer = currentItem.querySelector('.yg-video-container');
      const reversedVideoContainer = currentItem.querySelector('.yg-video-container-reversed');
      // 处理视频容器的显示和播放
      if(direction == 'prev') {
        this.backgroundItems.forEach((item) => {
          item.classList.remove('active');
        });
        this.backgroundItems[index].classList.add('active');
      }

      // 根据设备类型选择对应的视频
      const isMobile = window.innerWidth < 769;
      let video = videoContainer.querySelector(
        isMobile ? 'video[data-device="mobile"]' : 'video[data-device="pc"]'
      ) || videoContainer.querySelector('video');

      // 如果没有视频，改为渐隐渐显过渡
      if (!video) {
        const FADE_DURATION = 800; // ms，与 CSS transition 同步
        const currentItemEl = this.backgroundItems[this.currentIndex];
        const nextItemEl = this.backgroundItems[index];

        // 先触发渐隐
        nextItemEl.classList.add('active');

        setTimeout(() => {
          currentItemEl.classList.remove('active');

          this.items[this.currentIndex].classList.remove('active');
          this.items[index].classList.add('active');

          const progressBars = this.querySelectorAll('.yg-progress-bar-item');
          if (progressBars.length > 0) {
            progressBars[this.currentIndex].classList.remove('active');
            progressBars[index].classList.add('active');
          }

          const mobileItems = this.querySelectorAll('.yg-mobile-introduction-item');
          if (mobileItems.length > 0) {
            mobileItems[this.currentIndex].classList.remove('active');
            mobileItems[index].classList.add('active');
          }

          this.currentIndex = index;
          this.startAutoPlay();
        }, FADE_DURATION);

        return;
      }

      if (video) {
        this.stopAutoPlay();
        // 正放时重置到开头，倒放时不需要重置，倒放逻辑会自己处理
        if (direction !== 'prev') {
          video.currentTime = 0;
          videoContainer.classList.add('active');
        }

        // 通用的播放结束后的操作
        const onVideoEnd = () => {

          // 视频播放结束时移除当前容器的 active 类
          videoContainer.classList.remove('active');
          if(reversedVideoContainer) {
            reversedVideoContainer.classList.remove('active');
          }
          if(direction == 'next') {
            // 添加 active 类到下一个背景项
            this.backgroundItems.forEach((item) => {
              item.classList.remove('active');
            });
            const nextBackgroundItem = this.backgroundItems[index];
            if (nextBackgroundItem) {
              nextBackgroundItem.classList.add('active');
            }
          }


          // 继续自动播放
          this.startAutoPlay();
          this.items.forEach((item) => {
            item.classList.remove('no-show');
          });
          this.infoGoTo(index);
          this.currentIndex = index;
        };

        if (direction == 'prev') {
          // 检查是否有专门的倒放视频，如果有则正常播放
          const reversedVideo = reversedVideoContainer ? (
            isMobile
              ? reversedVideoContainer.querySelector('video[data-device="mobile"]')
              : reversedVideoContainer.querySelector('video[data-device="pc"]')
          ) || reversedVideoContainer.querySelector('video') : null;

          if (reversedVideo) {
            reversedVideoContainer.classList.add('active');
            // 有倒放视频，直接正常播放
            video = reversedVideo;
            video.currentTime = 0;
            video.play();
            video.onended = onVideoEnd;
          } else {
            // 没有倒放视频，使用自定义逻辑实现倒放
            video.pause(); // 初始时暂停视频

            // 等待视频元数据加载完成后再开始倒放
            const startReversePlayback = () => {
              const duration = video.duration;
              if (!duration || duration === Infinity || isNaN(duration)) {
                // 如果 duration 无效，等待 canplaythrough 事件
                video.addEventListener('canplaythrough', () => {
                  doReversePlayback(video.duration);
                }, { once: true });
                return;
              }
              doReversePlayback(duration);
            };

            const doReversePlayback = (duration) => {
              let currentTime = duration;
              const targetDuration = duration * 1000; // 目标毫秒数
              const startTime = performance.now();

              const reversePlayback = () => {
                const elapsed = performance.now() - startTime;
                currentTime = duration - (elapsed / 1000);

                if (currentTime <= 0) {
                  video.currentTime = 0;
                  onVideoEnd(); // 执行播放结束后的操作
                } else {
                  video.currentTime = currentTime;
                  video.reverseAnimationId = requestAnimationFrame(reversePlayback);
                }
              };

              // 开始倒放
              video.reverseAnimationId = requestAnimationFrame(reversePlayback);
            };

            // 如果视频元数据已加载，直接开始；否则等待 loadedmetadata
            if (video.readyState >= 2) {
              startReversePlayback();
            } else {
              video.addEventListener('loadedmetadata', () => {
                startReversePlayback();
              }, { once: true });
            }

            // 当视频结束或者被暂停时，停止倒放定时器
            video.onended = () => {
              if (video.reverseAnimationId) {
                cancelAnimationFrame(video.reverseAnimationId);
                video.reverseAnimationId = null;
              }
              onVideoEnd(); // 执行播放结束后的操作
            };
          }
        } else {
          // 正常播放
          video.play();
          video.onended = onVideoEnd; // 正常播放时监听播放结束事件
        }

        // 在视频播放时隐藏其他项
        this.items.forEach((item) => {
          item.classList.add('no-show');
        });
      }
    }

    next() {
      this.goTo(this.currentIndex + 1, 'next');
    }

    prev() {
      this.goTo(this.currentIndex - 1, 'prev');
    }
  }

  customElements.define('yg-camera-introduction', YGCameraIntroduction);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-card-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[id^="yg-card-grid-toggle-btn-"]').forEach(function (btn) {
    var sectionId = btn.id.replace('yg-card-grid-toggle-btn-', '');
    var grid = document.getElementById('yg-card-grid-' + sectionId);
    if (!grid) return;

    var label = btn.querySelector('.yg-toggle-label');
    var learnMoreText = label ? label.textContent.trim() : 'Learn More';
    var showLessText = btn.dataset.showLess || 'Show Less';
    var hiddenCards = grid.querySelectorAll('.yg-card--mobile-hidden');

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      if (!expanded) {
        hiddenCards.forEach(function (card) {
          card.classList.add('is-revealed');
        });
        btn.setAttribute('aria-expanded', 'true');
        if (label) label.textContent = showLessText;
      } else {
        hiddenCards.forEach(function (card) {
          card.classList.remove('is-revealed');
        });
        btn.setAttribute('aria-expanded', 'false');
        if (label) label.textContent = learnMoreText;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-collapse-item"] && !Shopify.designMode) return;
  try {
    
  class YgCollapse extends YGUtils {
    constructor() {
      super();
    }

    connectedCallback() {
      this.cacheDom();
      this.bindEvents();
    }

    cacheDom() {
      // tabs
      this.tabs = this.querySelectorAll('.yg-collapse-tab');

      // ✅ 移动端：只取 yg-collapse-item-mobile
      this.mobileItems = this.querySelectorAll('.yg-collapse-item-mobile');

      // PC 端内容
      this.modelItems = this.querySelectorAll('.yg-collapse-model .yg-collapse-model-item');

      // debug
      console.log('tabs:', this.tabs.length);
      console.log('mobileItems:', this.mobileItems.length);
      console.log('modelItems:', this.modelItems.length);
    }

    bindEvents() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.switchTab(index));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.switchTab(index);
          }
        });
      });
    }

    switchTab(index) {
      const isMobile = window.innerWidth < 1000;
      const targetTab = this.tabs[index];
      const isAlreadyActive = targetTab.classList.contains('active');

      if (isMobile) {
        if (isAlreadyActive) {
          // 移动端：当前项为active，再次点击收起
          targetTab.classList.remove('active');
          this.mobileItems[index].classList.remove('active');
        } else {
          this.tabs.forEach((tab, i) => {
            tab.classList.toggle('active', i === index);
          });
          this.mobileItems.forEach((item, i) => {
            item.classList.toggle('active', i === index);
          });
        }
        return;
      }

      // PC 端：保持原来的逻辑
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === index);
      });
      this.modelItems.forEach((item, i) => {
        item.classList.toggle('active', i === index);
      });
    }
  }

  // 防止重复注册
  if (!customElements.get('yg-collapse')) {
    customElements.define('yg-collapse', YgCollapse);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-expert-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGExpertCard extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      setContainerHeight() {
        this.style.setProperty('--container-height', this.scrollHeight + 'px');
      }

      init() {
        const container = this;
        this.setContainerHeight();
        window.addEventListener('resize', () => {
          this.setContainerHeight();
        });
        this._detailSwitchTimer = null;
        this._pendingExpertItem = null;
        const items = Array.from(container.querySelectorAll('.yg-expert-card-item'));



        const performExpertSwitch = (item) => {
          const cards = Array.from(container.querySelectorAll('.yg-expert-card-item'));

          const first = cards.map((el) => el.getBoundingClientRect());

          cards.forEach((el) => {
            el.classList.remove('is-expanded');
            el.classList.remove('is-detail-exit');
            el.classList.remove('is-detail-enter');
          });

          const lastCard = cards[cards.length - 1];
          const style = getComputedStyle(lastCard);

          const paddingTop = parseFloat(style.paddingTop);
          const paddingBottom = parseFloat(style.paddingBottom);

          let lastCardHeight = 0;

          if (window.innerWidth >= 700) {
            lastCardHeight = lastCard.querySelector('.yg-top-content').scrollHeight - paddingTop - paddingBottom + 120;
          } else {
            lastCardHeight = lastCard.querySelector('.yg-top-content').scrollHeight + 27;
          }

          lastCard.style.height = `${lastCardHeight}px`;

          container.appendChild(item);

          setTimeout(() => {
            lastCard.style.height = 'auto';
          }, 1300);

          const last = cards.map((el) => el.getBoundingClientRect());

          cards.forEach((el, i) => {
            const dy = first[i].top - last[i].top;

            if (dy) {
              el.style.transform = `translateY(${dy}px)`;
              el.style.transition = 'none';

              requestAnimationFrame(() => {
                el.style.transition = 'transform 1s cubic-bezier(.22,.61,.36,1)';

                el.style.transform = '';
              });
            }
          });

          item.classList.add('is-expanded');
          item.classList.add('is-detail-enter');
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              item.classList.remove('is-detail-enter');
            });
          });
        };

        const switchCard = (item) => {
          if (item.classList.contains('is-expanded')) {
            if (this._detailSwitchTimer) {
              clearTimeout(this._detailSwitchTimer);
              this._detailSwitchTimer = null;
            }
            this._pendingExpertItem = null;
            item.classList.remove('is-detail-exit');
            return;
          }

          const prevExpanded = container.querySelector('.yg-expert-card-item.is-expanded');

          this._pendingExpertItem = item;

          const runSwitch = () => {
            this._detailSwitchTimer = null;
            const target = this._pendingExpertItem;
            this._pendingExpertItem = null;
            if (!target) {
              return;
            }
            const stillExpanded = container.querySelector('.yg-expert-card-item.is-expanded');
            if (stillExpanded) {
              stillExpanded.classList.remove('is-detail-exit');
            }
            performExpertSwitch(target);
          };

          if (prevExpanded) {
            prevExpanded.classList.add('is-detail-exit');
            if (this._detailSwitchTimer) {
              clearTimeout(this._detailSwitchTimer);
            }
            this._detailSwitchTimer = setTimeout(runSwitch, 220);
            return;
          }

          runSwitch();
        };



        items.forEach((item) => {
          item.addEventListener('click', () => {
            switchCard(item);
          });
        });



        if (window.innerWidth < 700) {
          let startX = 0;
          let moveX = 0;

          container.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
          });

          container.addEventListener('touchmove', (e) => {
            const current = container.querySelector('.yg-expert-card-item.is-expanded');

            if (!current) return;

            moveX = e.touches[0].clientX - startX;


            const rotate = moveX * 0.06;


            const lift = Math.abs(moveX) * -0.15;

            current.style.transition = 'none';

            current.style.transform = `translate(${moveX}px,${lift}px) rotate(${rotate}deg)`;
          });

          container.addEventListener('touchend', () => {
            const current = container.querySelector('.yg-expert-card-item.is-expanded');

            if (!current) return;

            const cards = Array.from(container.querySelectorAll('.yg-expert-card-item'));


            if (Math.abs(moveX) < 60) {
              current.style.transition = 'transform .3s';
              current.style.transform = '';
              moveX = 0;
              return;
            }

            const direction = moveX > 0 ? 1 : -1;



            current.style.transition = 'transform .45s cubic-bezier(.22,.61,.36,1)';

            current.style.transform = `translate(${direction * 460}px,-260px)
           rotate(${direction * 32}deg)
           scale(.96)`;

            setTimeout(() => {
              const cards = Array.from(container.querySelectorAll('.yg-expert-card-item'));


              cards.forEach((el) => el.classList.remove('is-expanded'));


              const nextExpanded = cards[cards.length - 2];
              nextExpanded.classList.add('is-expanded');

              const collapsedItem = container.querySelector('.yg-expert-card-item:not(.is-expanded)');

              const placeholderHeight = collapsedItem.getBoundingClientRect().height;


              container.style.transition = 'padding 1.2s cubic-bezier(.22,.61,.36,1)';
              container.style.paddingTop = `${placeholderHeight}px`;
              current.style.height = '0';
              container.prepend(current);

              setTimeout(() => {



                current.style.transition = 'height 1s cubic-bezier(.22,.61,.36,1)';
                container.style.paddingTop = '';
                current.style.transform = '';
                current.style.height = 'auto';


                container.offsetHeight;
              }, 600);
            }, 450);

            moveX = 0;
          });
        }
      }
    }

    if (!customElements.get('yg-expert-card')) {
      customElements.define('yg-expert-card', YGExpertCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-help-center-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const normalizeHandle = (value) => {
      let normalized = value?.toString().trim().toLowerCase() || '';

      if (!normalized) return '';

      normalized = normalized.replace(/^https?:\/\/[^/]+/, '');
      normalized = normalized.split(/[?#]/)[0];
      normalized = normalized.replace(/^\/+|\/+$/g, '');

      if (!normalized) return '';

      const segments = normalized.split('/').filter(Boolean);

      return segments.length ? segments[segments.length - 1] : normalized;
    };

    const escapeHtml = (value) => {
      const div = document.createElement('div');
      div.textContent = value?.toString() || '';
      return div.innerHTML;
    };

    const readMenuLookup = (pathsScriptId) => {
      if (!pathsScriptId) return [];

      const script = document.getElementById(pathsScriptId);

      if (!script) return [];

      try {
        const entries = JSON.parse(script.textContent || '[]');

        return Array.isArray(entries)
          ? entries
              .map((entry) => {
                const handle = normalizeHandle(entry?.url || entry?.handle);

                if (!handle) return null;

                return {
                  handle,
                  title: entry?.title?.toString().trim() || '',
                  url: entry?.url || '',
                  path: Array.isArray(entry?.path)
                    ? entry.path.map((level) => level?.toString().trim()).filter(Boolean)
                    : [],
                  source: 'menu',
                };
              })
              .filter(Boolean)
          : [];
      } catch (error) {
        console.error('Failed to parse help center menu data:', error);
        return [];
      }
    };

    const isSamePath = (left = [], right = []) =>
      left.length === right.length && left.every((value, index) => value === right[index]);

    const hasPathPrefix = (path = [], prefix = []) => prefix.every((value, index) => path[index] === value);

    const getArticleUrlPrefix = (value) => {
      const normalized = value?.toString().trim() || '';

      if (!normalized) return '/blogs/help-center';

      const withoutOrigin = normalized.replace(/^https?:\/\/[^/]+/i, '');
      const cleanPath = withoutOrigin.split(/[?#]/)[0];
      const segments = cleanPath.split('/').filter(Boolean);

      if (segments.length >= 3 && segments[0] === 'blogs') {
        return `/${segments.slice(0, -1).join('/')}`;
      }

      return '/blogs/help-center';
    };

    const buildArticleUrl = (value, fallbackPrefix = '/blogs/help-center') => {
      const raw = value?.toString().trim() || '';

      if (!raw) return '#';

      if (/^https?:\/\//i.test(raw)) return raw;
      if (raw.startsWith('/')) return raw;

      const normalizedHandle = normalizeHandle(raw);

      return normalizedHandle ? `${fallbackPrefix}/${normalizedHandle}` : '#';
    };

    const buildMenuTree = (entries, parentPath = []) => {
      const submenus = [];
      const submenuMap = new Map();
      const articles = [];

      entries.forEach((entry) => {
        if (!hasPathPrefix(entry.path, parentPath)) return;

        if (entry.path.length === parentPath.length) {
          articles.push(entry);
          return;
        }

        const nextName = entry.path[parentPath.length];

        if (!submenuMap.has(nextName)) {
          const nextPath = [...parentPath, nextName];
          const submenu = {
            name: nextName,
            path: nextPath,
            children: buildMenuTree(entries, nextPath),
          };

          submenuMap.set(nextName, submenu);
          submenus.push(submenu);
        }
      });

      return { submenus, articles };
    };

    class YGSearchBox extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const form = this.querySelector('.yg-search-box-form');
        const input = form.querySelector('input[name="q"]');
        const clearBtn = form.querySelector('.yg-search-box-clear');
        const searchButtonMobile = this.querySelector('.yg-search-button-mobile');
        const searchButtonCancel = this.querySelector('.yg-search-button-cancel');
        input.dispatchEvent(new Event('change'));

        // 清除按钮显示/隐藏逻辑
        const toggleClearBtn = () => {
          if (input.value.trim().length > 0) {
            clearBtn.classList.add('visible');
          } else {
            clearBtn.classList.remove('visible');
          }
        };

        // 初始状态
        toggleClearBtn();

        // 输入时显示/隐藏
        input.addEventListener('input', toggleClearBtn);

        // 清除按钮点击事件
        clearBtn.addEventListener('click', () => {
          input.value = '';
          input.focus();
          input.dispatchEvent(new Event('change'));
          toggleClearBtn();
        });

        // 提交按钮
        const submitBtn = form.querySelector('.yg-search-box-submit');

        // 更新提交按钮状态
        const updateSubmitBtn = () => {
          if (input.value.trim().length > 0) {
            submitBtn.removeAttribute('disabled');
            submitBtn.style.opacity = '1';
            submitBtn.style.cursor = 'pointer';
          } else {
            submitBtn.setAttribute('disabled', 'true');
            submitBtn.style.opacity = '0.5';
            submitBtn.style.cursor = 'not-allowed';
          }
        };

        // 初始状态
        updateSubmitBtn();

        // 输入时更新按钮状态
        input.addEventListener('input', updateSubmitBtn);

        form.addEventListener('submit', (e) => {
          if (!input.value.trim()) {
            e.preventDefault();
            return;
          }
          e.preventDefault();
          const value = input.value;
          const searchUrl = form.dataset.jumpUrl + '?q=' + encodeURIComponent(value);
          window.location.href = window.RealseeUtmFlow
            ? window.RealseeUtmFlow.decorateUrl(searchUrl)
            : searchUrl;
        });

        // 移动端
        searchButtonMobile.addEventListener('click', () => {
          this.classList.add('active');
        });
        searchButtonCancel.addEventListener('click', () => {
          this.classList.remove('active');
        });
      }
    }
    if (!window.customElements.get('yg-search-box')) {
      window.customElements.define('yg-search-box', YGSearchBox);
    }

    class YGFeedback extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const feedback = this;
        const title = feedback.dataset.articleTitle;
        const $feedBackTitle = feedback.querySelector('.yg-feedback-titel');
        const $feedBackButtons = feedback.querySelector('.yg-feedback-buttons');
        const sendFeedbackTelemetry = (actionType) => {
          if (
            window.RealseeShopTelemetry &&
            typeof window.RealseeShopTelemetry.send === 'function'
          ) {
            window.RealseeShopTelemetry.send('likeClick', {
              url: window.location.href,
              action_type: actionType
            });
          }
        };
        if (feedback) {
          feedback.addEventListener('click', (e) => {
            if (e.target.classList.contains('yg-feedback-yes')) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'article_helpful',
                helpful: 'yes',
                article_title: title,
                article_path: window.location.pathname
              });;
              sendFeedbackTelemetry('1');
              $feedBackTitle.textContent = feedback.dataset.yesText;
              $feedBackButtons.setAttribute('hidden', 'true');
            }
            if (e.target.classList.contains('yg-feedback-no')) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'article_helpful',
                helpful: 'no',
                article_title: title,
                article_path: window.location.pathname
              });;
              sendFeedbackTelemetry('0');
              $feedBackTitle.textContent = feedback.dataset.noText;
              $feedBackButtons.setAttribute('hidden', 'true');
            }
          });
        }
      }
    }
    if (!window.customElements.get('yg-feedback')) {
      window.customElements.define('yg-feedback', YGFeedback);
    }

    class YGLeftMenu extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const menu = this;

        const header = menu.querySelector('.yg-menu-header');

        header.addEventListener('click', () => {
          menu.classList.toggle('yg-show-menu');
          menu.classList.toggle('yg-show-menu-pc');
        });

        // 点击关闭按钮时移除 yg-show-menu 类
        const closeBtn = menu.querySelector('.yg-menu-content-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            menu.classList.remove('yg-show-menu');
          });
        }
      }
    }
    if (!window.customElements.get('yg-left-menu')) {
      window.customElements.define('yg-left-menu', YGLeftMenu);
    }

    class YGHelpCenter extends HTMLElement {
      constructor() {
        super();
        this.menuEntries = readMenuLookup(this.dataset.menuPathsId);
        this.excelEntries = [];
        this.allEntries = [...this.menuEntries];
        this.articleUrlPrefix = getArticleUrlPrefix(window.location.pathname);
        this.init();
      }

      async loadMenuData() {
        try {
          const fileUrl = this.dataset.menuUrl;
          if (!fileUrl) return this.allEntries;
          const response = await fetch(fileUrl);
          if (!response.ok) {
            throw new Error(`Failed to fetch menu data: ${response.status}`);
          }
          const data = await response.arrayBuffer();
          const workbook = XLSX.read(data, { type: 'array' });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          if (json.length < 2) return this.allEntries;

          const headers = json[0];
          const titleIndex = headers.indexOf('Article Title');
          const handleIndex = headers.indexOf('Article Handle');
          if (titleIndex === -1 || handleIndex === -1) return this.allEntries;

          this.excelEntries = json
            .slice(1)
            .map((row) => {
              const handle = normalizeHandle(row[handleIndex]);
              const title = row[titleIndex]?.toString().trim() || '';
              const path = [];

              for (let i = 0; i < titleIndex; i++) {
                const level = row[i]?.toString().trim();

                if (level) {
                  path.push(level);
                }
              }

              if (!handle || !title) return null;

              return {
                handle,
                title,
                url: buildArticleUrl(handle, this.articleUrlPrefix),
                path,
                source: 'excel',
              };
            })
            .filter(Boolean);

          const mergedEntries = [...this.menuEntries];
          const knownHandles = new Set(this.menuEntries.map((entry) => entry.handle));

          this.excelEntries.forEach((entry) => {
            if (!knownHandles.has(entry.handle)) {
              mergedEntries.push(entry);
            }
          });

          this.allEntries = mergedEntries;
          return this.allEntries;
        } catch (e) {
          console.error(e);
          this.allEntries = [...this.menuEntries];
          return this.allEntries;
        }
      }

      getArticleEntry(articleHandle) {
        const normalizedHandle = normalizeHandle(articleHandle);

        if (!normalizedHandle) return null;

        return this.allEntries.find((entry) => entry.handle === normalizedHandle) || null;
      }

      getArticlePath(articleHandle) {
        return this.getArticleEntry(articleHandle)?.path || [];
      }

      extractArticleUrl(article) {
        if (!article) return '#';

        if (typeof article === 'string') {
          return buildArticleUrl(article, this.articleUrlPrefix);
        }

        if (article.url) return article.url;

        return article.handle ? buildArticleUrl(article.handle, this.articleUrlPrefix) : '#';
      }

      getMenuTree(levelName, currentLevel = 1, parentPath = []) {
        if (!levelName) return null;
        const result = { submenus: [], articles: [] };
        this.menuData.forEach((item) => {
          // 判断是否属于当前路径
          let belongs = true;
          for (let i = 1; i < currentLevel; i++) {
            if (item['level' + i] !== parentPath[i - 1]) {
              belongs = false;
              break;
            }
          }
          if (!belongs) return;

          if (item['level' + currentLevel] !== levelName) return;

          const nextLevelValue = item['level' + (currentLevel + 1)];

          if (nextLevelValue && !result.submenus.find((s) => s.name === nextLevelValue)) {
            result.submenus.push({
              name: nextLevelValue,
              level: currentLevel + 1,
              parentPath: [...parentPath, levelName],
              children: this.getMenuTree(nextLevelValue, currentLevel + 1, [...parentPath, levelName]),
            });
          }

          if (!this.hasDeeperLevel(item, currentLevel) && item.articleTitle) {
            result.articles.push({
              title: item.articleTitle,
              handle: item.articleHandle,
              url: this.extractArticleUrl(item.articleHandle),
            });
          }
        });
        return result;
      }
      // ⚡ 新增：渲染上一篇/下一篇文章
      getEntriesForNavigation() {
        const currentEntry = this.getArticleEntry(this.dataset.articleHandle);

        if (!currentEntry) return this.allEntries;

        if (currentEntry.path.length > 0) {
          return this.allEntries.filter((entry) => entry.path[0] === currentEntry.path[0]);
        }

        return this.allEntries;
      }

      renderArticleNavigation() {
        const navContainer = this.querySelector('.yg-previous-and-next');
        if (!navContainer) return;
        const currentEntry = this.getArticleEntry(this.dataset.articleHandle);
        if (!currentEntry) return;

        const mergedSiblings = this.getEntriesForNavigation().filter((entry) => isSamePath(entry.path, currentEntry.path));
        const mergedCurrentIndex = mergedSiblings.findIndex((entry) => entry.handle === currentEntry.handle);
        const mergedPrev = mergedCurrentIndex > 0 ? mergedSiblings[mergedCurrentIndex - 1] : null;
        const mergedNext = mergedCurrentIndex >= 0 ? mergedSiblings[mergedCurrentIndex + 1] || null : null;

        navContainer.innerHTML = `
            ${
              mergedPrev
                ? `<a href="${this.extractArticleUrl(mergedPrev)}" class="yg-prev-article">
                  <span class="yg-prev-article-label">
                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M15 19L8 12L15 5"></path>
                    </svg>
                    Previous
                  </span>
                  <span class="yg-prev-article-title">
                    ${escapeHtml(mergedPrev.title)}
                  </span>
                  </a>`
                : '<span class="prev-article"></span>'
            }
            ${
              mergedNext
                ? `<a href="${this.extractArticleUrl(mergedNext)}" class="yg-next-article">
                  <span class="yg-next-article-label">
                    Next
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 5L16 12L9 19"></path>
                    </svg>
                  </span>
                  <span class="yg-next-article-title">
                    ${escapeHtml(mergedNext.title)}
                  </span>
                  </a>`
                : '<span class="next-article"></span>'
            }
            `;
        return;
        {

        // 获取文章路径
        const legacySiblingsByPath = this.getEntriesForNavigation().filter((entry) => isSamePath(entry.path, currentEntry.path));
        const parentLevelIndex = path.length; // 最后一级作为父级
        const parentLevel = path[parentLevelIndex - 1];
        console.log('parentLevel', parentLevel, parentLevelIndex);
        // 同父级的文章
        const siblings = this.menuData.filter((item) => {
          const itemPath = [];
          for (let i = 1; i <= this.maxDepth; i++) {
            if (item['level' + i]) itemPath.push(item['level' + i]);
            else break;
          }
          return itemPath[parentLevelIndex - 1] === parentLevel && item.articleTitle;
        });
        console.log('siblings', siblings);
        const currentIndex = siblings.findIndex((a) => a.articleHandle.toLowerCase() === articleHandle.toLowerCase());
        console.log('currentIndex', currentIndex);

        const prev = siblings[currentIndex - 1] || null;
        const next = siblings[currentIndex + 1] || null;
        navContainer.innerHTML = `
            ${
              prev
                ? `<a href="${this.extractArticleUrl(prev.articleHandle)}" class="yg-prev-article">
                  <span class="yg-prev-article-label">
                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M15 19L8 12L15 5"></path>
                    </svg>
                    Previous
                  </span>
                  <span class="yg-prev-article-title">
                    ${prev.articleTitle}
                  </span>
                  </a>`
                : '<span class="prev-article"></span>'
            }
            ${
              next
                ? `<a href="${this.extractArticleUrl(next.articleHandle)}" class="yg-next-article">
                  <span class="yg-next-article-label">
                    Next
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 5L16 12L9 19"></path>
                    </svg>
                  </span>
                  <span class="yg-next-article-title">
                    ${next.articleTitle}
                  </span>
                  </a>`
                : '<span class="next-article"></span>'
            }
            `;
        }
      }

      renderMenuItems(menuData, articlePath = [], currentLevel = 1) {
        const currentArticleHandle = this.dataset.articleHandle;
        if (!menuData) return '';
        let html = '';

        const normalizedCurrentHandle = normalizeHandle(currentArticleHandle);

        menuData.submenus.forEach((submenu) => {
          const isOnPath = hasPathPrefix(articlePath, submenu.path);

          html += `
                <div class="yg-menu-group ${isOnPath ? 'yg-menu-expanded' : ''}"
                    data-submenu-name="${submenu.name}"
                    data-parent-path="${submenu.path.join(',')}">
                <div class="yg-menu-group-header">
                    <span class="yg-menu-label">${escapeHtml(submenu.name)}</span>
                    <svg class="yg-menu-expand-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </div>
                <div class="yg-menu-group-content">
                    ${this.renderMenuItems(submenu.children, articlePath, currentLevel + 1)}
                </div>
                </div>
            `;
        });

        menuData.articles.forEach((article) => {
          const isActive = article.handle === normalizedCurrentHandle;
          html += `<a href="${this.extractArticleUrl(article)}" class="yg-menu-item yg-menu-article ${isActive ? 'active' : ''}">
                ${escapeHtml(article.title)}
              </a>`;
        });

        return html;
        // 子菜单
        menuData.submenus.forEach((submenu) => {
          // 当前菜单是否在文章路径上
          const isOnPath = articlePath[currentLevel] == submenu.name;

          html += `
                <div class="yg-menu-group ${isOnPath ? 'yg-menu-expanded' : ''}"
                    data-submenu-level="${submenu.level}"
                    data-submenu-name="${submenu.name}"
                    data-parent-path="${submenu.parentPath.join(',')}">
                <div class="yg-menu-group-header">
                    <span class="yg-menu-label">${submenu.name}</span>
                    <svg class="yg-menu-expand-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </div>
                <div class="yg-menu-group-content">
                    ${this.renderMenuItems(submenu.children, articlePath, currentLevel + 1)}
                </div>
                </div>
            `;
        });

        // 文章
        menuData.articles.forEach((article) => {
          const isActive = article.handle.toLowerCase() == currentArticleHandle.toLowerCase();
          html += `<a href="${article.url}" class="yg-menu-item yg-menu-article ${isActive ? 'active' : ''}">
                ${article.title}
              </a>`;
        });

        return html;
      }

      bindMenuEvents(root = null) {
        const container = root || this.querySelector('.yg-menu-content');
        const groups = container.querySelectorAll(':scope > .yg-menu-group');
        const self = this;

        groups.forEach((group) => {
          const header = group.querySelector('.yg-menu-group-header');
          header.addEventListener('click', () => {
            group.classList.toggle('yg-menu-expanded');
          });

          const groupContent = group.querySelector('.yg-menu-group-content');
          if (groupContent) self.bindMenuEvents(groupContent);
        });
      }

      renderMenu() {
        const content = this.querySelector('.yg-menu-content');
        const pathContainer = this.querySelector('.yg-article-path');
        const articleHandle = this.dataset.articleHandle;
        const articleTitle = this.dataset.articleTitle;

        if (!this.allEntries.length || !articleHandle) {
          content.innerHTML = '<p>Loading menu...</p>';
          return;
        }

        const currentEntry = this.getArticleEntry(articleHandle);
        if (!currentEntry) {
          content.innerHTML = '<p>Menu not found for this article</p>';
          return;
        }

        if (pathContainer) {
          pathContainer.innerHTML = this.renderArticlePath(currentEntry.path, articleTitle);
        }

        const rootPath = currentEntry.path.length > 0 ? [currentEntry.path[0]] : [];
        const mergedMenuData = buildMenuTree(this.getEntriesForNavigation(), rootPath);

        content.innerHTML = this.renderMenuItems(mergedMenuData, currentEntry.path);
        this.bindMenuEvents();
        this.renderArticleNavigation();
        return;

        if (!this.menuData.length || !articleHandle) {
          content.innerHTML = '<p>Loading menu...</p>';
          return;
        }

        const articlePath = this.getArticlePath(articleHandle);
        if (!articlePath.length) {
          content.innerHTML = '<p>Menu not found for this article</p>';
          return;
        }

        // ⚡ 渲染文章路径到 .yg-article-path
        if (pathContainer) {
          pathContainer.innerHTML = this.renderArticlePath(articlePath, articleTitle);
        }

        const menuData = this.getMenuTree(articlePath[0], 1);
        content.innerHTML = this.renderMenuItems(menuData, articlePath);
        this.bindMenuEvents();

        // ⚡ 新增：渲染上一篇/下一篇
        this.renderArticleNavigation();
      }

      // 渲染文章路径（一级菜单 > 二级菜单 > ... > 当前文章）
      renderArticlePath(articlePath, articleTitle) {
        let html = '<nav class="yg-path-nav" aria-label="Breadcrumb"><ol>';

        // 渲染每个层级的菜单和当前文章
        articlePath.forEach((levelName, index) => {
          html += `
                  <li class="yg-path-item">
                    <span class="yg-path-text">${escapeHtml(levelName)}</span>
                  </li>
                `;
        });
        html += `
          <li class="yg-path-item yg-path-current">
            <span class="yg-path-text">${escapeHtml(articleTitle)}</span>
          </li>
        `;

        html += '</ol></nav>';
        return html;
      }

      init() {
        this.loadMenuData().then(() => this.renderMenu());
      }
    }

    if (!window.customElements.get('yg-help-center')) {
      window.customElements.define('yg-help-center', YGHelpCenter);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-carousel"] && !Shopify.designMode) return;
  try {
    
  class YgImageCarousel extends HTMLElement {
    connectedCallback() {
      var raw = this.dataset.bgColors || '';
      this._bgColors = raw ? raw.split('|||') : [];
      var sectionId = this.dataset.sectionId;
      this._infoList = document.getElementById('yg-carousel-info-' + sectionId);
      this._fade = document.getElementById('yg-carousel-fade-' + sectionId);

      this._updateCard(0);
      this._waitForSwiper();
    }

    _updateCard(index) {
      var bg = this._bgColors[index] || this._bgColors[0] || 'rgba(255,255,255,0.06)';
      this.style.background = bg;

      if (this._fade) {
        this._fade.style.background = 'linear-gradient(to right, transparent, ' + bg + ')';
      }

      if (this._infoList) {
        var items = this._infoList.querySelectorAll('[data-info-index]');
        items.forEach(function(item) {
          var idx = parseInt(item.getAttribute('data-info-index'));
          item.classList.toggle('is-active', idx === index);
        });
      }
    }

    _waitForSwiper() {
      var self = this;
      var swiperEl = this.querySelector('.yg-swiper');
      if (!swiperEl) return;
      var check = setInterval(function() {
        if (swiperEl.swiper) {
          clearInterval(check);
          self._updateCard(swiperEl.swiper.realIndex || 0);
          swiperEl.swiper.on('slideChange', function() {
            self._updateCard(swiperEl.swiper.realIndex);
          });
        }
      }, 50);
    }
  }

  if (!customElements.get('yg-image-carousel')) {
    customElements.define('yg-image-carousel', YgImageCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGImageTabsContainer extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const isMobile = window.innerWidth <= 699;
        if (isMobile) {
          this.initMobileSwiper();
        } else {
          this.showPCLayout();
        }
      }
      async initMobileSwiper() {
        await window.waitForElementVisible?.(this);
        const SwiperCtor = await window.loadSwiper();
        const tabSlider = this.querySelector('.yg-media-tabs .yg-tab-slider');
        const thumbnails = new SwiperCtor(this.querySelector('.yg-media-tabs'), {
          slidesPerView: 'auto',
          spaceBetween: 0,
          navigation: {
            nextEl: this.querySelector('.yg-swiper-next'),
            prevEl: this.querySelector('.yg-swiper-prev'),
          },
        });
        const swiper = new SwiperCtor(this.querySelector('.yg-media-swiper'), {
          slidesPerView: 1,
          allowTouchMove: false,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          thumbs: {
            swiper: thumbnails,
          },
          on: {
            init: (e) => {
              const thumbnailActive = this.querySelector('.swiper-slide-thumb-active');
              if (thumbnailActive && tabSlider) {
                tabSlider.style.setProperty('--active-left', thumbnailActive.offsetLeft + 'px');
                tabSlider.style.setProperty('--active-width', thumbnailActive.offsetWidth + 'px');
              }
            },
          },
        });

        const perfButton = this.querySelector('.yg-swiper-prev');
        const nextButton = this.querySelector('.yg-swiper-next');
        if (perfButton) {
          perfButton.addEventListener('click', () => {
            swiper.slidePrev();
          });
        }
        if (nextButton) {
          nextButton.addEventListener('click', () => {
            swiper.slideNext();
          });
        }

        swiper.on('slideChange', () => {
          const thumbnailActive = this.querySelector('.swiper-slide-thumb-active');
          if (thumbnailActive && tabSlider) {
            tabSlider.style.setProperty('--active-left', thumbnailActive.offsetLeft + 'px');
            tabSlider.style.setProperty('--active-width', thumbnailActive.offsetWidth + 'px');
          }
          const activeIndex = swiper.activeIndex;
          this.querySelectorAll('.yg-mobile-content-panel').forEach((panel) => {
            panel.classList.toggle('is-active', parseInt(panel.dataset.index) === activeIndex);
          });
        });
      }
      showPCLayout() {
        const pcLayout = this.querySelector('.yg-media-slide[style*="display: none"]');
        if (pcLayout) {
          pcLayout.style.display = 'flex';
        }
      }
    }
    if (!customElements.get('yg-image-tabs-container')) {
      customElements.define('yg-image-tabs-container', YGImageTabsContainer);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-media-accordion')) {
    customElements.define('yg-media-accordion', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.media = Array.from(this.querySelectorAll('[data-accordion-media]'));

        this.items.forEach((item, index) => {
          const button = item.querySelector('button');
          button?.addEventListener('click', () => {
            if (item.classList.contains('is-active')) {
              this.setItemActive(item, false);
              this.media[index]?.querySelector('video')?.pause();
              return;
            }
            this.activate(index);
          }, {
            signal: this.abortController.signal,
          });
        });

        this.querySelectorAll('[data-video-toggle]').forEach((button) => {
          const mediaItem = button.closest('[data-accordion-media]');
          const video = mediaItem?.querySelector('video');
          if (!video) return;

          button.addEventListener('click', () => {
            if (video.paused) {
              video.play().catch(() => this.syncVideoControl(mediaItem));
            } else {
              video.pause();
            }
          }, { signal: this.abortController.signal });

          video.addEventListener('play', () => this.syncVideoControl(mediaItem), { signal: this.abortController.signal });
          video.addEventListener('pause', () => this.syncVideoControl(mediaItem), { signal: this.abortController.signal });
        });

        document.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest?.('[data-accordion-item]');
          const index = this.items.indexOf(item);
          if (index >= 0 && this.contains(item)) this.activate(index);
        }, { signal: this.abortController.signal });

        this.activate(0);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.media?.forEach((item) => item.querySelector('video')?.pause());
      }

      activate(activeIndex) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.items.forEach((item, index) => {
          this.setItemActive(item, index === activeIndex);
        });

        this.media.forEach((item, index) => {
          const active = index === activeIndex;
          const video = item.querySelector('video');
          item.classList.toggle('is-active', active);
          if (!video) return;
          if (!active || reduceMotion) {
            video.pause();
            this.syncVideoControl(item);
            return;
          }
          video.currentTime = 0;
          video.play().catch(() => this.syncVideoControl(item));
        });
      }

      setItemActive(item, active) {
        const content = item.querySelector('.yg-media-accordion__content');
        content?.getAnimations().forEach((animation) => animation.cancel());
        item.classList.remove('is-collapsing');

        const wasActive = item.classList.contains('is-active');
        item.querySelector('button')?.setAttribute('aria-expanded', String(active));
        if (wasActive === active) return;

        const from = content?.getBoundingClientRect().height;
        item.classList.toggle('is-active', active);
        if (!content || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const to = content.getBoundingClientRect().height;
        if (!active) item.classList.add('is-collapsing');

        const animation = content.animate(
          [{ height: `${from}px` }, { height: `${to}px` }],
          { duration: 300, easing: 'cubic-bezier(0, 0, 0.5, 1)', fill: 'both' },
        );
        animation.onfinish = () => {
          item.classList.remove('is-collapsing');
          animation.cancel();
        };
      }

      syncVideoControl(mediaItem) {
        const video = mediaItem.querySelector('video');
        const button = mediaItem.querySelector('[data-video-toggle]');
        if (!video || !button) return;
        const state = video.paused ? 'paused' : 'playing';
        button.dataset.state = state;
        button.setAttribute('aria-label', state === 'paused' ? 'Play video' : 'Pause video');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGMediaTab extends HTMLElement {
      constructor() {
        super();
        this.initSwiper();
      }
      async initSwiper() {
        await window.waitForElementVisible?.(this);
        const SwiperCtor = await window.loadSwiper();
        const tabSlider = this.querySelector('.yg-media-tabs .yg-tab-slider');
        const sectionEl = this;
        const thumbnails = new SwiperCtor(this.querySelector('.yg-media-tabs'), {
          slidesPerView: 'auto',
          spaceBetween: 0,
          navigation: {
            nextEl: this.querySelector('.yg-swiper-next'),
            prevEl: this.querySelector('.yg-swiper-prev'),
          },
        });
        const swiper = new SwiperCtor(this.querySelector('.yg-media-swiper'), {
          slidesPerView: 1,
          allowTouchMove: false,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          thumbs: {
            swiper: thumbnails,
          },
          on: {
            init: (e) => {
              const thumbnailActive = this.querySelector('.swiper-slide-thumb-active');
              tabSlider.style.setProperty('--active-left', thumbnailActive.offsetLeft + 'px');
              tabSlider.style.setProperty('--active-width', thumbnailActive.offsetWidth + 'px');
            },
          },
        });

        const perfButton = this.querySelector('.yg-swiper-prev');
        const nextButton = this.querySelector('.yg-swiper-next');
        perfButton.addEventListener('click', () => {
          swiper.slidePrev();
        });
        nextButton.addEventListener('click', () => {
          swiper.slideNext();
        });

        swiper.on('slideChange', () => {
          const thumbnailActive = this.querySelector('.swiper-slide-thumb-active');
          tabSlider.style.setProperty('--active-left', thumbnailActive.offsetLeft + 'px');
          tabSlider.style.setProperty('--active-width', thumbnailActive.offsetWidth + 'px');

          let thumbnailIndex = Array.from(thumbnailActive.parentElement.children).indexOf(thumbnailActive);
          thumbnails.slideToLoop(swiper.realIndex);
        });
      }
    }
    if (!customElements.get('yg-media-tab-container')) {
      customElements.define('yg-media-tab-container', YGMediaTab);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-with-content"] && !Shopify.designMode) return;
  try {
    
  class YGAnchorLink extends HTMLElement {
    #observedSection = null;
    static observer = null;
    static sectionToItem = new Map();
    static isScroll = false;

    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
      this.sections = null;
    }

    connectedCallback() {
      this.sections = document.querySelectorAll('#main .shopify-section');
      this.addEventListener('click', this.itemClick);

      const sectionNumber = Number(this.getAttribute('data-section-number') || 0);
      if (!this.sections?.length || !Number.isFinite(sectionNumber) || sectionNumber <= 0) return;

      const section = this.sections[sectionNumber - 1];
      if (!section) return;

      this.#observedSection = section;
      YGAnchorLink.#ensureObserver();
      YGAnchorLink.sectionToItem.set(section, this);
      YGAnchorLink.observer.observe(section);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);

      if (this.#observedSection && YGAnchorLink.observer) {
        YGAnchorLink.sectionToItem.delete(this.#observedSection);
        YGAnchorLink.observer.unobserve(this.#observedSection);
      }
    }

    static #ensureObserver() {
      if (YGAnchorLink.observer) return;

      YGAnchorLink.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const item = YGAnchorLink.sectionToItem.get(entry.target);
            if (!YGAnchorLink.isScroll) {
              item && item.setActiveFromObserver();
            }
          });
        },
        {
          root: null,
          threshold: 0.01,
          rootMargin: '-20% 0px -70% 0px',
        }
      );
    }

    setActiveFromObserver() {
      let id = this.getAttribute('data-id');
      let $anchorList;
      if (id) {
        $anchorList = this.parentElement
          ? Array.from(document.querySelectorAll(`yg-anchor-link[data-id="${id}"]`))
          : [];
      } else {
        $anchorList = this.parentElement ? Array.from(this.parentElement.querySelectorAll('yg-anchor-link')) : [];
      }

      $anchorList.forEach((el, index) => {
        el.classList.toggle(
          'active',
          el.getAttribute('data-section-number') === this.getAttribute('data-section-number')
        );

        if (el === this) {
          this.labelClick(index);
        }
      });

      document.dispatchEvent(
        new CustomEvent('YG:anchor-change', {
          bubbles: true,
        })
      );
    }

    labelClick(index) {
      // 添加新的活动状态
      const parent = this.parentElement;
      if (parent && this.isScrollable(parent)) {
        const containerRect = parent.getBoundingClientRect();
        const targetRect = this.getBoundingClientRect();
        const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 260;

        parent.scrollTo({
          left: scrollLeft,
          behavior: 'smooth',
        });
      }
    }

    isScrollable(el) {
      if (!el) return false;

      const style = window.getComputedStyle(el);
      const overflowY = style.overflowY;
      const overflowX = style.overflowX;

      const canScrollVertically = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
      const canScrollHorizontally = (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

      return canScrollVertically || canScrollHorizontally;
    }

    itemClick() {
      const sectionNumber = this.getAttribute('data-section-number');
      YGAnchorLink.isScroll = true;
      this.setActiveFromObserver();
      if (sectionNumber == 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else {
        const section = this.sections[sectionNumber - 1];
        if (!section) return;
        const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }

      setTimeout(() => {
        YGAnchorLink.isScroll = false;
      }, 600);
    }
  }
  if (!window.customElements.get('yg-anchor-link')) {
    window.customElements.define('yg-anchor-link', YGAnchorLink);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-photography"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      class YGPhotography extends HTMLElement {
        constructor() {
          super();
          this.init();
        }
        init() {
          const items = this.querySelectorAll('.yg-photography-item');
          this.style.setProperty('--item-height', items[0].clientHeight + 'px');
          items.forEach(item => {
            console.log('content-height',item.querySelector('.yg-collapse-content').offsetHeight);
            item.style.setProperty('--content-height', item.querySelector('.yg-collapse-content').scrollHeight + 'px');
          });

          let activeItem = null;
          let showTimer = null;

          items.forEach(item => {
            item.addEventListener('mouseenter', () => {
              if (item.classList.contains('yg-photography-item-active')) {
                return;
              }

              // 切换时立即清除上一个定时器
              if (showTimer) {
                clearTimeout(showTimer);
                showTimer = null;
              }

              items.forEach(i => {
                i.classList.remove('yg-photography-item-active');
                i.classList.remove('yg-content-show');
              });

              item.classList.add('yg-photography-item-active');
              activeItem = item;

              showTimer = setTimeout(() => {
                if (item === activeItem && item.classList.contains('yg-photography-item-active')) {
                  item.classList.add('yg-content-show');
                }
                showTimer = null;
              }, 200);
            });

            item.addEventListener('click', () => {
              if(item.classList.contains('yg-photography-item-active-mobile')) {
                item.classList.remove('yg-photography-item-active-mobile');
                return;
              }
              items.forEach(i => {
                i.classList.remove('yg-photography-item-active-mobile');
              });
              item.classList.add('yg-photography-item-active-mobile');
              item.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
          });
        }
      }
      if (!window.customElements.get('yg-photography')) {
        window.customElements.define('yg-photography', YGPhotography);
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps-v1"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'accordionList': this.querySelectorAll('.yg-process-steps-item'),
        'progressBars': this.querySelectorAll('.yg-process-steps-progress-bar'),
        'controls': this.querySelectorAll('.yg-process-steps-media')
      }

      return this.#sectionEl
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', (event) => {
        if (event.detail.id) {
          this.currentStep(event.detail.id);
        }
      });
      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          this.nextStep(event.detail.id);
        }
      });
    }

    nextStep(id) {
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });
      
      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      this.pauseAllVideos();
      const videoEl = this.getVideoById(id);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-slide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGScrollSlide extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.stickyEl = this.querySelector('.yg-scroll-slide-sticky');
        this.textContent_ = this.querySelector('.yg-text-content');
        this.sectionHeader = this.querySelector('.yg-text-content .section-header');
        this.bottomContent = this.querySelector('.yg-text-content .yg-bottom-content');
        this.stopsList = this.querySelector('.yg-text-content .yg-stops-list');

        // 总滚动高度 = 2000px（与 CSS height: calc(2000px + 100vh) 对应）
        this.totalScroll = 2000;

        // 文字各层出现区间（依次错开）
        this.headerStart  = 300;  this.headerEnd  = 700;
        this.bottomStart  = 600;  this.bottomEnd  = 900;
        this.stopsStart   = 800;  this.stopsEnd   = 1100;

        // 视频自动播放
        if ('IntersectionObserver' in window) {
          this.mediaObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const video = entry.target;

              if (entry.isIntersecting) {
                video.muted = true;
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          }, {
            threshold: 0.25,
            rootMargin: '100px 0px'
          });

          this.querySelectorAll('video').forEach((video) => {
            this.mediaObserver.observe(video);
          });
        }

        this.handleScroll();
      }

      disconnectedCallback() {
        if (this.mediaObserver) {
          this.mediaObserver.disconnect();
        }
      }

      clamp(val, min, max) {
        return Math.min(max, Math.max(min, val));
      }

      lerp(val, start, end) {
        return this.clamp((val - start) / (end - start), 0, 1);
      }

      handleScroll() {
        const onScroll = () => {
          if (!this.stickyEl) return;
          const rect = this.stickyEl.getBoundingClientRect();
          // sticky 吸顶时 rect.top === 0
          if (rect.top !== 0) return;

          const scrollDistance = -this.getBoundingClientRect().top;

          // --- section-header opacity ---
          const headerOpacity = this.lerp(scrollDistance, this.headerStart, this.headerEnd);
          if (this.sectionHeader) {
            this.sectionHeader.style.setProperty('--header-opacity', headerOpacity);
          }

          // --- yg-bottom-content opacity ---
          const bottomOpacity = this.lerp(scrollDistance, this.bottomStart, this.bottomEnd);
          if (this.bottomContent) {
            this.bottomContent.style.setProperty('--bottom-opacity', bottomOpacity);
          }

          // --- yg-stops-list opacity ---
          const stopsOpacity = this.lerp(scrollDistance, this.stopsStart, this.stopsEnd);
          if (this.stopsList) {
            this.stopsList.style.setProperty('--stops-opacity', stopsOpacity);
          }

          // 全部显示后加 is-visible 类（避免继续受 scroll 驱动）
          const allVisible = headerOpacity >= 1 && bottomOpacity >= 1 && stopsOpacity >= 1;
          if (allVisible) {
            this.textContent_.classList.add('is-visible');
          } else {
            this.textContent_.classList.remove('is-visible');
          }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        // 初始化时执行一次，处理页面刷新后的位置
        onScroll();
      }
    }

    if (!customElements.get('yg-scroll-slide')) {
      customElements.define('yg-scroll-slide', YGScrollSlide);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGScrollVideo extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.wrapper = this;
        this.header = this.querySelector('.section-header');
        this.bottom = this.querySelector('.yg-bottom-content');
        this.mediaWrapper = this.querySelector('.yg-media-wrapper');
        this.media = this.querySelector('.yg-media-inner');
        this.stickyEl = this.querySelector('.yg-scroll-video-sticky');
        this.loadVideos()
        const style = getComputedStyle(this.querySelector('.yg-scroll-video-inner'));
        this.sectionWidth =
          this.querySelector('.yg-scroll-video-inner').offsetWidth -
          parseFloat(style.paddingLeft) -
          parseFloat(style.paddingRight);
        this.innerWidth = window.innerWidth;
        this.mediaHeight = this.sectionWidth / parseFloat(this.media.dataset.aspectRatio);
        this.mediaHeightMobile = this.sectionWidth / parseFloat(this.media.dataset.aspectRatioMobile);
        this.media.style.width = '0px';
        this.media.style.height = '2px';
        this.progress = 0;
        this.progressSecond = 0;
        this.mediaType = this.media.dataset.type;
        this.handleScroll();
      }

      loadVideos() {
        const wrapperObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const videos = entry.target.querySelectorAll('.yg-video')
              console.log('videos',videos);

              videos.forEach((video) => {
                video.src = video.getAttribute('data-src');
              });
            }
          });
        });
        wrapperObserver.observe(this.wrapper);
      }
      handleScroll() {
        const totalScroll = 2000;
        const halfScroll = totalScroll / 2;
        const sectionTop = this.wrapper.offsetTop;
        let lastScrollY = window.scrollY;
        window.addEventListener('scroll', () => {
          const currentScrollY = window.scrollY;

          if (this.stickyEl.getBoundingClientRect().top >  window.innerHeight / 2 || this.stickyEl.getBoundingClientRect().top < 0) return;

          const scrollDistance = -this.wrapper.getBoundingClientRect().top + window.innerHeight / 2;
          if (currentScrollY > lastScrollY) {


            if (this.progress < 100) {
              this.progress = Math.min(100, Math.max(0, scrollDistance / halfScroll * 100));

              this.wrapper.style.setProperty('--progress', this.progress);
              this.wrapper.style.setProperty('--reverse-progress', 100 - this.progress);

              this.media.style.width = `${(this.innerWidth * this.progress) / 100}px`;

              if (this.progress === 100) {
                this.mediaWrapper.classList.add('center');
              }
            } else {
              this.progressSecond = Math.min(
                100,
                Math.max(0, (scrollDistance - halfScroll) / halfScroll * 100)
              );
              if(this.innerWidth < 700) {
                this.media.style.height = `${(this.mediaHeightMobile * this.progressSecond) / 100}px`;
              } else {
                this.media.style.height = `${(this.mediaHeight * this.progressSecond) / 100}px`;
              }
              const mediaWidth = this.innerWidth - ((this.innerWidth - this.sectionWidth) * this.progressSecond) / 100;
              if(this.innerWidth < 700) {
                this.media.style.width = `${mediaWidth}px`;
              } else {
                this.media.style.width = `${mediaWidth}px`;
              }
            }
            if(this.progressSecond == 100) {
              this.media.classList.add('full-display');
            } else {
              this.media.classList.remove('full-display');
            }
            if(this.mediaType == 'video' && this.progressSecond == 100) {
              this.media.classList.add('playing');
              this.media.querySelectorAll('video').forEach(video => {
                video.play();
              });
            } else {
                this.media.classList.remove('playing');
                this.media.querySelectorAll('video').forEach(video => {
                  video.pause();
                  video.currentTime = 0;
                });
            }
          } else if (currentScrollY < lastScrollY) {


            if (this.progressSecond > 0) {
              this.progressSecond = Math.min(
                100,
                Math.max(0, (scrollDistance - halfScroll) / halfScroll * 100)
              );

              let mediaHeight = 0
              if(this.innerWidth < 700) {
                mediaHeight = Math.max(2, (this.mediaHeightMobile * this.progressSecond) / 100);
              } else {
                mediaHeight = Math.max(2, (this.mediaHeight * this.progressSecond) / 100);
              }
              this.media.style.height = `${mediaHeight}px`;

              const mediaWidth = this.innerWidth - ((this.innerWidth - this.sectionWidth) * this.progressSecond) / 100;

              this.media.style.width = `${mediaWidth}px`;

              if (this.progressSecond === 0) {
                this.mediaWrapper.classList.remove('center');
              }
            } else {
              this.progress = Math.min(100, Math.max(0, scrollDistance / halfScroll * 100));

              this.wrapper.style.setProperty('--progress', this.progress);
              this.wrapper.style.setProperty('--reverse-progress', 100 - this.progress);

              this.media.style.width = `${(this.innerWidth * this.progress) / 100}px`;
            }

            if(this.mediaType == 'video' && this.progressSecond == 100) {
              this.media.classList.add('playing');
              this.media.querySelectorAll('video').forEach(video => {
                video.play();
              });
            } else {
                this.media.classList.remove('playing');
                this.media.querySelectorAll('video').forEach(video => {
                  video.pause();
                  video.currentTime = 0;
                });
            }

            if(this.progressSecond == 100) {
              this.media.classList.add('full-display');
            } else {
              this.media.classList.remove('full-display');
            }
          }

          lastScrollY = currentScrollY;
        });
      }
    }

    if (!customElements.get('yg-scroll-video')) {
      customElements.define('yg-scroll-video', YGScrollVideo);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-show-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGShowVideo extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.media = this.querySelector('.yg-media-inner');
        this.mediaType = this.media.dataset.type;
        this.isMobile = window.innerWidth < 700;
        this.animated = false;
        this._setInitialSize();
        this._observe();
      }

      _setInitialSize() {
        // PC 端：用 scaleX 实现窄视窗，不需要手动设置宽高，CSS 控制初始状态
        // 移动端同样使用 CSS transition
        const innerEl = this.querySelector('.yg-show-video-inner');
        const style = getComputedStyle(innerEl);
        const contentW = innerEl.offsetWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const isMobile = window.innerWidth < 700;
        const ar = isMobile
          ? parseFloat(this.media.dataset.aspectRatioMobile)
          : parseFloat(this.media.dataset.aspectRatio);
        const h = contentW / ar;
        this.media.style.width = `${contentW}px`;
        this.media.style.height = `${h}px`;
      }

      _trigger() {
        if (this.animated) return;
        this.animated = true;

        // 添加动画 class，CSS transition 接管
        this.media.classList.add('yg-animated');

        // 动画结束后启动视频播放
        if (this.mediaType === 'video') {
          this.media.addEventListener('transitionend', () => {
            if (!this.media.classList.contains('playing')) {
              this.media.classList.add('playing');
              this.media.querySelectorAll('video').forEach(v => v.play());
            }
          }, { once: true });
        }
      }

      _observe() {
        // 当 section 中心进入视口中间 50% 区域时触发
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this._trigger();
                observer.disconnect();
              }
            });
          },
          {
            // rootMargin: 上下各缩进 25vh，即元素需滚动到视口中间 50% 才触发
            rootMargin: '-25% 0px -25% 0px',
            threshold: 0
          }
        );
        observer.observe(this.media);
      }
    }

    if (!customElements.get('yg-show-video')) {
      customElements.define('yg-show-video', YGShowVideo);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-showcase-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGVRShowcase extends HTMLElement {
      constructor() {
        super();
        this.vrActivated = false;
        this.autoTimer = null; // 用于非视频 slide 的自动轮播
        this.currentVideoEndedHandler = null; // 保存上一个视频 onended handler
        this.initSwiper();
        this.initVRButton();
        this.initVisibilityObserver();
      }

      activateVRSlide(slide) {
        const iframe = slide?.querySelector('.yg-vr-iframe');

        if (!iframe) return;

        iframe.hidden = false;
        iframe.style.display = 'block';
        iframe.querySelector('yg-vr-frame')?.requestLoad();
      }

      syncActiveVRSlide() {
        if (!this.vrActivated) return;

        this.activateVRSlide(this.querySelector('.yg-vr-slide.swiper-slide-active'));
      }

      syncVRFrames() {
        this.querySelectorAll('yg-vr-frame').forEach((frame) => frame.requestLoad());
      }

      initVisibilityObserver() {
        if (this._visibilityObserver) return;

        this._visibilityObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.syncActiveVRSlide();
            this.syncVRFrames();
          }
        }, {
          threshold: [0, 0.01],
        });

        this._visibilityObserver.observe(this);
      }

      clearTimers() {
        if (this.autoTimer) {
          clearTimeout(this.autoTimer);
          this.autoTimer = null;
        }
        // 移除上一个视频事件
        if (this.currentVideoEndedHandler) {
          const video = this.currentVideoEndedHandler.video;
          video.onended = null;
          this.currentVideoEndedHandler = null;
        }
      }

      handleVideo(swiper) {
        this.clearTimers(); // 切换 slide 先清理旧逻辑
        const currentSlide = swiper.slides[swiper.realIndex];
        const ygVideo = currentSlide.querySelector('yg-video');

        // 暂停其它所有视频
        this.querySelectorAll('yg-video').forEach((videoEl) => {
          if (videoEl !== ygVideo) videoEl.pauseVideo();
        });

        if (ygVideo) {
          customElements.whenDefined('yg-video').then(() => {
            ygVideo.playVideo();
            const iframe = ygVideo.querySelector('.yg-video-iframe');
            const progressBar = currentSlide.querySelector('.yg-play-progress-bar');

            if (iframe) {
              const setupVideoEvents = (videoEl) => {
                videoEl.onloadedmetadata = () => {
                  if (progressBar) {
                    progressBar.style.width = '100%';
                    progressBar.style.transition = `width ${videoEl.duration}s linear`;
                  }
                };
                videoEl.onplay = () => {
                  if (progressBar) {
                    progressBar.style.width = '100%';
                    progressBar.style.transition = `width ${videoEl.duration}s linear`;
                  }
                };
                videoEl.onended = () => {
                  if (progressBar) {
                    progressBar.style.width = '0%';
                    progressBar.style.transition = 'width 0s';
                  }
                  swiper.slideNext();
                };
                // 保存上一个视频事件，切换 slide 时可以清除
                this.currentVideoEndedHandler = { video: videoEl };
              };

              // 处理 pc / mobile 视频逻辑统一
              const pcVideo = iframe.querySelector('.hide-mobile') || iframe;
              const mobileVideo = iframe.querySelector('.hide-pc') || iframe;

              if (window.innerWidth > 700) {
                setupVideoEvents(pcVideo);
              } else {
                setupVideoEvents(mobileVideo);
              }
            }
          });
        } else {
          // 非视频 slide 自动 5 秒切换
          this.autoTimer = setTimeout(() => {
            swiper.slideNext();
          }, 5000);
        }
      }

      async initSwiper() {
        await window.waitForElementVisible?.(this);
        const SwiperCtor = await window.loadSwiper();
        const swiper = new SwiperCtor(this.querySelector('.yg-vr-swiper'), {
          slidesPerView: 1,
          allowTouchMove: true,
          effect: 'fade',
          fadeEffect: { crossFade: true },
          on: {
            init: (e) => {
              this.syncActiveVRSlide();
              this.syncVRFrames();
              this.handleVideo(e);
            },
          },
        });

        swiper.on('slideChange', () => {
          this.syncActiveVRSlide();
          this.syncVRFrames();
          this.handleVideo(swiper);
        });
      }

      initVRButton() {
        this.querySelectorAll('.yg-vr-view-btn').forEach((btn) => {
          btn.addEventListener('click', () => {
            const slide = btn.closest('.yg-vr-slide');
            this.vrActivated = true;
            this.activateVRSlide(slide);
          });
        });
      }
    }

    if (!customElements.get('yg-vr-showcase')) {
      customElements.define('yg-vr-showcase', YGVRShowcase);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-switching-medie-text"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl;

      this.#sectionEl = {
        accordionList: this.querySelectorAll('.yg-process-steps-item'),
        progressBars: this.querySelectorAll('.yg-process-steps-progress-bar'),
        controls: this.querySelectorAll('.yg-process-steps-media'),
      };

      return this.#sectionEl;
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', (event) => {
        if (event.detail.id) {
          // 检查该 id 是否属于当前组件实例
          const myIds = Array.from(this.querySelectorAll('[data-id]')).map((el) => el.getAttribute('data-id'));
          if (myIds.includes(event.detail.id)) {
            this.currentStep(event.detail.id);
          }
        }
      });
      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          // 检查该 id 是否属于当前组件实例
          const myIds = Array.from(this.querySelectorAll('[data-id]')).map((el) => el.getAttribute('data-id'));
          if (myIds.includes(event.detail.id)) {
            this.nextStep(event.detail.id);
          }
        }
      });
    }

    nextStep(id) {
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });

      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          // console.log('item',item);

          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl && typeof videoEl.pauseVideo === 'function') {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      this.pauseAllVideos();
      const videoEl = this.getVideoById(id);
      if (videoEl && typeof videoEl.playVideo === 'function') {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  class YGProcessStepsMobile extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
      this.swiperInstance = null;
      this.initSwiper();
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl;

      this.#sectionEl = {
        progressBars: this.querySelectorAll('.yg-process-steps-progress-bar'),
        controls: this.querySelectorAll('.yg-process-steps-media'),
      };

      return this.#sectionEl;
    }

    connectedCallback() {

      // 监听进度条完成事件，自动切换到下一个
      document.addEventListener('YG:progress-end', (event) => {

        if (event.detail.id) {
          // 检查该 id 是否属于当前组件实例
          const myIds = Array.from(this.querySelectorAll('[data-id]')).map((el) => el.getAttribute('data-id'));
          if (myIds.includes(event.detail.id)) {
            this.nextStep(event.detail.id);
          }
        }
      });
    }

    // 初始化第一项
    initFirstStep() {
      const slides = this.querySelectorAll('.yg-process-steps-slide');
      if (slides.length === 0) return;

      const firstSlide = slides[0];
      const firstId = firstSlide.querySelector('.yg-process-steps-media')?.getAttribute('data-id');
      if (firstId) {
        // 模拟 YG:dropdown-open 事件，触发第一项的激活
        this.currentStep(firstId);
      }
    }

    // 切换到下一步
    nextStep(id) {
      const slides = this.querySelectorAll('.yg-process-steps-slide');
      const swiper = this.swiperInstance;

      if (!swiper || slides.length === 0) return;

      // 找到当前步骤的索引
      let currentIndex = 0;
      slides.forEach((slide, index) => {
        const media = slide.querySelector('.yg-process-steps-media');
        if (media && media.getAttribute('data-id') === id) {
          currentIndex = index;
        }
      });

      // 计算下一个索引（循环播放）
      const nextIndex = (currentIndex + 1) % slides.length;
      this.currentStepIndex = nextIndex;

      // 使用 swiper.slideTo 切换到下一个 slide
      swiper.slideToLoop(nextIndex);
    }

    // 切换到指定步骤
    currentStep(id) {
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    // 设置活动控制
    setActiveControl(id) {
      // 移动端不需要设置 active 类，轮播会自动处理显示
      // 暂停所有视频
      this.pauseAllVideos();
    }

    // 启动指定ID的进度条
    async startProgressForId(id) {
      // 等待 custom element 注册完成
      await customElements.whenDefined('yg-progress-bar');
      this.$sectionEl['progressBars']?.forEach((item, i) => {

        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;

          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    // 播放指定ID的视频
    playVideo(id) {
      const videoEl = this.getVideoById(id);
      if (videoEl && typeof videoEl.playVideo === 'function') {
        videoEl.playVideo();
      }
    }

    // 根据ID获取视频元素
    getVideoById(id) {
      const slides = this.querySelectorAll('.yg-process-steps-slide');
      for (const slide of slides) {
        const media = slide.querySelector('.yg-process-steps-media');
        if (media && media.getAttribute('data-id') === id) {
          const videoEl = media.querySelector('yg-video');
          if (videoEl) {
            return videoEl;
          }
        }
      }
      return null;
    }

    // 暂停所有视频
    pauseAllVideos() {
      const videoElements = this.querySelectorAll('yg-video');
      videoElements.forEach((video) => {
        try {

          if (video && typeof video.pauseVideo === 'function') {
            video.pauseVideo();
          }
        } catch (e) {
          // 忽略错误
        }
      });
    }

    // 初始化轮播
    async initSwiper() {
      await window.waitForElementVisible?.(this);
      const SwiperCtor = await window.loadSwiper();
      const tabSlider = this.querySelector('.yg-process-steps-tabs .yg-process-steps-tab-slider');
      const sectionEl = this;

      // 初始化标签轮播
      const thumbnails = new SwiperCtor(this.querySelector('.yg-process-steps-tabs'), {
        slidesPerView: 'auto',
        spaceBetween: 0,
        navigation: {
          nextEl: this.querySelector('.yg-swiper-next'),
          prevEl: this.querySelector('.yg-swiper-prev'),
        },
      });

      // 初始化内容轮播
      const swiper = new SwiperCtor(this.querySelector('.yg-process-steps-swiper'), {
        slidesPerView: 1,
        allowTouchMove: true, // 允许触摸滑动
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true, // 启用循环
        thumbs: {
          swiper: thumbnails,
        },
        on: {
          init: (e) => {
            this.swiperInstance = e;

            // 初始化滑块位置
            const thumbnailActive = this.querySelector('.swiper-slide-thumb-active');
            if (thumbnailActive && tabSlider) {
              tabSlider.style.setProperty('--active-left', thumbnailActive.offsetLeft + 'px');
              tabSlider.style.setProperty('--active-width', thumbnailActive.offsetWidth + 'px');
            }
            // this.initFirstStep()
          }
        },
      });
      swiper.on('slideChange', () => {
          // 更新滑块位置
            const thumbnailActive = this.querySelector('.swiper-slide-thumb-active');

            if (thumbnailActive && tabSlider) {

              tabSlider.style.setProperty('--active-left', thumbnailActive.offsetLeft + 'px');
              tabSlider.style.setProperty('--active-width', thumbnailActive.offsetWidth + 'px');
            }

            // 获取当前 slide
            const slides = this.querySelectorAll('.yg-process-steps-slide');
            const currentSlide = slides[swiper.realIndex];

            if (currentSlide) {
              const media = currentSlide.querySelector('.yg-process-steps-media');
              const currentId = media?.getAttribute('data-id');

              if (currentId) {
                // 触发当前项的激活，相当于 YG:dropdown-open 事件
                this.currentStep(currentId);
              }
            }
        });
        swiper.on('slideChangeTransitionEnd', () => {
          // 确保切换动画结束后更新索引
            this.currentStepIndex = swiper.realIndex;
        });

      // 添加上一个/下一个按钮事件
      const prevButton = this.querySelector('.yg-swiper-prev');
      const nextButton = this.querySelector('.yg-swiper-next');

      prevButton?.addEventListener('click', () => {
        swiper.slidePrev();
      });

      nextButton?.addEventListener('click', () => {
        swiper.slideNext();
      });

      // 保存 swiper 实例引用
      this.swiperInstance = swiper;
    }
  }

  if (!customElements.get('yg-process-steps-mobile')) {
    customElements.define('yg-process-steps-mobile', YGProcessStepsMobile);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tab-slider"] && !Shopify.designMode) return;
  try {
    
  class YgTabSlider extends YGUtils {
    constructor() {
      super();
      this.resizeTimeout = null;
      this.isMobile = window.innerWidth <= 699;
      this.autoTimer = null; // 自动轮播定时器
    }

    connectedCallback() {
      setTimeout(() => {
        this.initSwiper();
        this.bindResizeHandler();
      }, 100);
    }

    disconnectedCallback() {
      if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
      if (this.autoTimer) clearTimeout(this.autoTimer);
      window.removeEventListener('resize', this.handleResize);
    }

    bindResizeHandler() {
      this.handleResize = this.handleResize.bind(this);
      window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
      if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        const newIsMobile = window.innerWidth <= 699;
        if (newIsMobile !== this.isMobile) {
          this.isMobile = newIsMobile;
          if (this.thumbsInstance) this.thumbsInstance.destroy();
          if (this.mainInstance) this.mainInstance.destroy();
          this.initSwiper();
        }
      }, 250);
    }


    handleSlideChange(swiper) {
      const currentSlide = swiper.slides[swiper.activeIndex];
      const ygVideo = currentSlide.querySelector('yg-video');
      const tabSlider = this.querySelector('.yg-tab-slider-bg');

      // 更新 tab slider 高亮
      const thumbnailActive = this.querySelector('.swiper-slide-thumb-active');
      if (thumbnailActive && tabSlider) {
        tabSlider.style.setProperty('--active-left', thumbnailActive.offsetLeft + 'px');
        tabSlider.style.setProperty('--active-width', thumbnailActive.offsetWidth + 'px');
      }

      // 清除旧定时器
      if (this.autoTimer) {
        clearTimeout(this.autoTimer);
        this.autoTimer = null;
      }

      // 如果当前 slide 没有视频，自动轮播
      if (!ygVideo) {
        if (this.dataset.autoplay !== 'true') return;
        this.autoTimer = setTimeout(() => {
          swiper.slideNext();
        }, 5000);
        return;
      }

      // 视频 slide
      customElements.whenDefined('yg-video').then(() => {
        // 标志位，防止重复 play
        if (!ygVideo._isPlaying) {
          // 暂停其他视频
          this.querySelectorAll('yg-video').forEach((videoEl) => {
            if (videoEl !== ygVideo && videoEl._isPlaying) {
              videoEl._isPlaying = false;
              videoEl.pauseVideo();
            }
          });

          // 播放当前视频
          ygVideo._isPlaying = true;
          ygVideo.playVideo()?.catch((err) => {
            if (err.name !== 'AbortError') console.error(err);
          });

          // 视频结束回调
          const videoIframe = ygVideo.querySelector('.yg-video-iframe');
          if (videoIframe) {
            videoIframe.onended = () => {
              ygVideo._isPlaying = false;
              swiper.slideNext();
            };
          }
        }
      });
    }


    async initSwiper() {
      await window.waitForElementVisible?.(this);
      const SwiperCtor = await window.loadSwiper();
      const thumbsSwiperEl = this.querySelector('.yg-tab-slider-thumbs-swiper');
      const mainSwiperEl = this.querySelector('.yg-tab-slider-main-swiper');
      const tabSlider = this.querySelector('.yg-tab-slider-bg');

      if (!thumbsSwiperEl || !mainSwiperEl) return;

      // 初始化 thumbs Swiper（Tab 导航）
      const thumbsInstance = new SwiperCtor(thumbsSwiperEl, {
        spaceBetween: 0,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        navigation: this.isMobile && this.dataset.navigation === 'true'
          ? {
              nextEl: this.querySelector('.yg-tab-slider-thumbs .yg-swiper-next'),
              prevEl: this.querySelector('.yg-tab-slider-thumbs .yg-swiper-prev'),
            }
          : false,
      });

      // 初始化 main Swiper（内容展示）
      const mainInstance = new SwiperCtor(mainSwiperEl, {
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: this.dataset.autoplay === 'true' || this.dataset.navigation === 'true',
        thumbs: { swiper: thumbsInstance },
        navigation: !this.isMobile && this.dataset.navigation === 'true'
          ? {
              nextEl: this.querySelector('.yg-tab-slider-main .swiper-button-next'),
              prevEl: this.querySelector('.yg-tab-slider-main .swiper-button-prev'),
            }
          : false,
        on: {
          init: (swiper) => this.handleSlideChange(swiper),
          slideChange: (swiper) => this.handleSlideChange(swiper),
        },
      });

      // 保存实例
      this.thumbsInstance = thumbsInstance;
      this.mainInstance = mainInstance;
    }
  }

  // 注册自定义元素
  if (!customElements.get('yg-tab-slider')) {
    customElements.define('yg-tab-slider', YgTabSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGTabsList extends HTMLElement {
      constructor() {
        super();
        this._activeIndex = 0;
      }

      connectedCallback() {
        this.initTabs();
      }

      async initTabs() {
        await window.waitForElementVisible?.(this);
        const SwiperCtor = await window.loadSwiper();
        const navEl = this.querySelector('.yg-tabs-nav');
        const contentEl = this.querySelector('.yg-tabs-content-swiper');
        if (!navEl || !contentEl) return;

        const prevBtn = this.querySelector('.yg-swiper-prev');
        const nextBtn = this.querySelector('.yg-swiper-next');
        const checkOverflow = () => {
          const canScroll = navEl.scrollWidth > navEl.clientWidth;
          if (prevBtn) prevBtn.classList.toggle('is-hidden', !canScroll);
          if (nextBtn) nextBtn.classList.toggle('is-hidden', !canScroll);
          this._updateNavBtns();
        };
        checkOverflow();
        window.addEventListener('resize', checkOverflow);

        this._navSwiper = new SwiperCtor(navEl, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          watchSlidesProgress: true,
          on: {
            init: () => this.updateTabSlider(),
            slideChange: () => this.updateTabSlider(),
          },
        });

        this._contentSwiper = new SwiperCtor(contentEl, {
          slidesPerView: 1,
          allowTouchMove: false,
          effect: 'fade',
          fadeEffect: { crossFade: true },
          autoHeight: true,
          thumbs: { swiper: this._navSwiper },
          on: {
            init: (swiper) => {
              this.syncActiveState(swiper.realIndex);
              this.updateTabSlider(this._navSwiper, swiper);
              this._updateNavBtns();
              this._applyActivePanelZoneSettings();
            },
            slideChange: (swiper) => {
              this.syncActiveState(swiper.realIndex);
              this.updateTabSlider(this._navSwiper, swiper);
              this._updateNavBtns();
              this._applyActivePanelZoneSettings();
            },
          },
        });

        this.querySelectorAll('.yg-tab-btn').forEach((btn, index) => {
          btn.addEventListener('click', () => {
            if (!this._contentSwiper) return;
            this._contentSwiper.slideTo(index);
          });
        });

        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            if (!this._contentSwiper) return;
            this._contentSwiper.slidePrev();
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            if (!this._contentSwiper) return;
            this._contentSwiper.slideNext();
          });
        }

        this.syncActiveState(0);
        this.updateTabSlider(this._navSwiper, this._contentSwiper);
        this._updateNavBtns();
      }

      syncActiveState(idx) {
        const panels = this.querySelectorAll('.yg-tabs-content-swiper .yg-tab-panel');
        const btns = this.querySelectorAll('.yg-tab-btn');
        const total = panels.length;
        if (!total) return;
        const safeIdx = Math.max(0, Math.min(idx, total - 1));

        panels.forEach((p, i) => {
          p.classList.toggle('is-active', i === safeIdx);
        });

        btns.forEach((b, i) => {
          b.setAttribute('aria-selected', i === safeIdx ? 'true' : 'false');
        });

        this._activeIndex = safeIdx;
      }

      _applyActivePanelZoneSettings() {
        const panels = this.querySelectorAll('.yg-tabs-content-swiper .yg-tab-panel');
        const activePanel = panels[this._activeIndex];
        if (!activePanel) return;

        const swiperEl = activePanel.querySelector('yg-swiper');
        if (swiperEl && swiperEl.hasAttribute('data-pc-no-carousel')) {
          this._applyZoneSettings(swiperEl);
        }
      }

      _updateNavBtns() {
        const panels = this.querySelectorAll('.yg-tabs-content-swiper .yg-tab-panel');
        const total = panels.length;
        const prevBtn = this.querySelector('.yg-swiper-prev');
        const nextBtn = this.querySelector('.yg-swiper-next');
        if (prevBtn && !prevBtn.classList.contains('is-hidden')) {
          prevBtn.classList.toggle('swiper-button-disabled', this._activeIndex <= 0);
        }
        if (nextBtn && !nextBtn.classList.contains('is-hidden')) {
          nextBtn.classList.toggle('swiper-button-disabled', this._activeIndex >= total - 1);
        }
      }

      updateTabSlider(thumbnails = null, swiper = null) {
        const tabSlider = this.querySelector('.yg-tabs-nav .yg-tab-slider');
        const activeTab =
          this.querySelector('.yg-tab-btn.swiper-slide-thumb-active') ||
          this.querySelector('.yg-tab-btn[aria-selected="true"]');

        if (!tabSlider || !activeTab) return;

        tabSlider.style.setProperty('--active-left', activeTab.offsetLeft + 'px');
        tabSlider.style.setProperty('--active-width', activeTab.offsetWidth + 'px');

        if (thumbnails && swiper) {
          if (typeof thumbnails.slideToLoop === 'function') {
            thumbnails.slideToLoop(swiper.realIndex);
          } else {
            thumbnails.slideTo(swiper.realIndex);
          }
        }
      }




      _applyZoneSettings(swiperEl) {
        const swiper = swiperEl.swiper;
        if (!swiper) return;
        const autoplayDelay = parseInt(swiperEl.getAttribute('data-mobile-autoplay') || '0', 10);
        const w = window.innerWidth;
        if (w >= 880) {
          // Desktop: disable autoplay/loop/centeredSlides
          if (swiper.autoplay && swiper.autoplay.running) swiper.autoplay.stop();
          swiper.params.loop = false;
          swiper.params.centeredSlides = false;
          swiper.update();
        } else if (w >= 550) {
          // Tablet: enable autoplay/loop/centeredSlides
          swiper.params.loop = true;
          swiper.params.centeredSlides = true;
          swiper.update();
          if (autoplayDelay && swiper.autoplay && !swiper.autoplay.running) {
            swiper.autoplay.start();
          }
        } else {
          // Mobile: disable autoplay/loop/centeredSlides, keep dots
          if (swiper.autoplay && swiper.autoplay.running) swiper.autoplay.stop();
          swiper.params.loop = false;
          swiper.params.centeredSlides = false;
          swiper.update();
        }
      }
    }

    if (!customElements.get('yg-tabs-list-container')) {
      customElements.define('yg-tabs-list-container', YGTabsList);
    }

    // Apply initial breakpoint settings to all pc-no-carousel panels and listen to resize
    function applyAllZoneSettings() {
      document
        .querySelectorAll('yg-swiper[data-pc-no-carousel]')
        .forEach(function (swiperEl) {
          const swiper = swiperEl.swiper;
          if (!swiper) return;
          const autoplayDelay = parseInt(swiperEl.getAttribute('data-mobile-autoplay') || '0', 10);
          const w = window.innerWidth;
          if (w >= 880) {
            if (swiper.autoplay && swiper.autoplay.running) swiper.autoplay.stop();
            swiper.params.loop = false;
            swiper.params.centeredSlides = false;
            swiper.update();
          } else if (w >= 550) {
            swiper.params.loop = true;
            swiper.params.centeredSlides = true;
            swiper.update();
            if (autoplayDelay && swiper.autoplay && !swiper.autoplay.running) {
              swiper.autoplay.start();
            }
          } else {
            if (swiper.autoplay && swiper.autoplay.running) swiper.autoplay.stop();
            swiper.params.loop = false;
            swiper.params.centeredSlides = false;
            swiper.update();
          }
        });
    }

    // Run after all swipers are initialized
    let initAttempts = 0;
    const initTimer = setInterval(function () {
      initAttempts++;
      const allSwipers = document.querySelectorAll('yg-swiper[data-pc-no-carousel]');
      const allReady = Array.from(allSwipers).every(function (el) {
        return !!el.swiper;
      });
      if (allReady || initAttempts > 50) {
        clearInterval(initTimer);
        applyAllZoneSettings();
        window.addEventListener('resize', applyAllZoneSettings);
      }
    }, 100);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-text-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGTextTabsContainer extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      async init() {
        await window.waitForElementVisible?.(this);
        const SwiperCtor = await window.loadSwiper();
        const tabSlider = this.querySelector('.yg-media-tabs .yg-tab-slider');
        const thumbnails = new SwiperCtor(this.querySelector('.yg-media-tabs'), {
          slidesPerView: 'auto',
          spaceBetween: 0,
          navigation: {
            nextEl: this.querySelector('.yg-swiper-next'),
            prevEl: this.querySelector('.yg-swiper-prev'),
          },
        });

        const swiper = new SwiperCtor(this.querySelector('.yg-media-swiper'), {
          slidesPerView: 1,
          allowTouchMove: false,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          thumbs: {
            swiper: thumbnails,
          },
          on: {
            init: () => {
              this.updateTabSlider(tabSlider);
              this.syncTabWrapper();
            },
            slideChange: () => {
              this.updateTabSlider(tabSlider);
            },
          },
        });

        const prevButton = this.querySelector('.yg-swiper-prev');
        const nextButton = this.querySelector('.yg-swiper-next');
        if (prevButton) {
          prevButton.addEventListener('click', () => {
            swiper.slidePrev();
          });
        }
        if (nextButton) {
          nextButton.addEventListener('click', () => {
            swiper.slideNext();
          });
        }
      }

      updateTabSlider(tabSlider) {
        const thumbnailActive = this.querySelector('.yg-media-tabs .swiper-slide-thumb-active');
        if (thumbnailActive && tabSlider) {
          tabSlider.style.setProperty('--active-left', thumbnailActive.offsetLeft + 'px');
          tabSlider.style.setProperty('--active-width', thumbnailActive.offsetWidth + 'px');
        }
      }

      syncTabWrapper() {
        // 将 tab 栏包裹层与图片列宽度对齐
        const imageColumn = this.querySelector('.yg-media-slide .yg-image-column');
        const tabWrapper = this.querySelector('.yg-image-column-tab-wrapper');
        if (!imageColumn || !tabWrapper) return;

        const align = () => {
          const rect = imageColumn.getBoundingClientRect();
          const containerRect = this.getBoundingClientRect();
          tabWrapper.style.paddingLeft = (rect.left - containerRect.left) + 'px';
          tabWrapper.style.paddingRight = (containerRect.right - rect.right) + 'px';
        };

        align();
        window.addEventListener('resize', align);
      }
    }

    if (!customElements.get('yg-text-tabs-container')) {
      customElements.define('yg-text-tabs-container', YGTextTabsContainer);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-trusted-vR-experience"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGTrustedVRExperience extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const readMore = this.querySelector('.yg-read-more');
        const readMoreText = readMore.querySelector('span');
        if (readMore) {
          readMore.addEventListener('click', () => {
            if (this.classList.contains('is-expanded')) {
              this.classList.remove('is-expanded');
              readMoreText.textContent = 'Read More';
            } else {
              this.classList.add('is-expanded');
              readMoreText.textContent = 'Read Less';
            }
          });
        }
      }
    }
    if (!customElements.get('yg-trusted-vr-experience')) {
      customElements.define('yg-trusted-vr-experience', YGTrustedVRExperience);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-vr-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGVRShowcase extends HTMLElement {
      constructor() {
        super();
        this.vrActivated = false;
        this._visibilityObserver = null;
        this.initSwiper();
        this.initVRButton();
        this.initVisibilityObserver();
      }

      activateVRSlide(slide) {
        const iframe = slide?.querySelector('.yg-vr-iframe');

        if (!iframe) return;

        iframe.hidden = false;
        iframe.style.display = 'block';
        iframe.querySelector('yg-vr-frame')?.requestLoad();
      }

      syncActiveVRSlide() {
        if (!this.vrActivated) return;

        this.activateVRSlide(this.querySelector('.yg-vr-slide.swiper-slide-active'));
      }

      syncVRFrames() {
        this.querySelectorAll('yg-vr-frame').forEach((frame) => frame.requestLoad());
      }

      initVisibilityObserver() {
        if (this._visibilityObserver) return;

        this._visibilityObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.syncActiveVRSlide();
            this.syncVRFrames();
          }
        }, {
          threshold: [0, 0.01],
        });

        this._visibilityObserver.observe(this);
      }

      handleVideo(swiper) {
        const currentSlide = swiper.slides[swiper.realIndex];
        const ygVideo = currentSlide.querySelector('yg-video');
        const playProgressBar = currentSlide.querySelector('.yg-play-progress-bar');

        if (!ygVideo) return;

        customElements.whenDefined('yg-video').then(() => {
          // 暂停其他视频
          this.querySelectorAll('yg-video').forEach((videoEl) => {
            if (videoEl !== ygVideo) videoEl.pauseVideo();
          });

          ygVideo.playVideo();
          const videoType = ygVideo.getAttribute('data-type');

          if (videoType === 'video') {
            const pcVideo = ygVideo.querySelector('.yg-video-iframe.hide-mobile');
            const mobileVideo = ygVideo.querySelector('.yg-video-iframe.hide-pc');
            let videoEl =
              window.innerWidth > 700 && pcVideo ? pcVideo : mobileVideo || ygVideo.querySelector('.yg-video-iframe');

            if (!videoEl) return;

            const updateProgress = () => {
              if (!playProgressBar) return;
              playProgressBar.style.width = '100%';
              playProgressBar.style.transition = `width ${videoEl.duration - 0.2}s linear`;
            };

            videoEl.addEventListener('loadedmetadata', updateProgress);
            videoEl.addEventListener('play', updateProgress);
            videoEl.onended = () => {
              if (playProgressBar) {
                playProgressBar.style.width = '0%';
                playProgressBar.style.transition = 'width 0s linear';
              }

              swiper.slideNext();
            };
          }
        });
      }

      async initSwiper() {
        await window.waitForElementVisible?.(this);
        const SwiperCtor = await window.loadSwiper();
        const hasTabs = !!this.querySelector('.yg-vr-tabs');
        let thumbnails = null;

        if (hasTabs) {
          thumbnails = new SwiperCtor(this.querySelector('.yg-vr-tabs'), {
            slidesPerView: 'auto',
            spaceBetween: 0,
            navigation: {
              nextEl: this.querySelector('.yg-swiper-next'),
              prevEl: this.querySelector('.yg-swiper-prev'),
            },
            on: {
              init: () => this.updateTabSlider(),
              slideChange: () => this.updateTabSlider(),
            },
          });
        }

        const swiper = new SwiperCtor(this.querySelector('.yg-vr-swiper'), {
          slidesPerView: 1,
          allowTouchMove: false,
          effect: 'fade',
          fadeEffect: { crossFade: true },
          thumbs: hasTabs ? { swiper: thumbnails } : undefined,
          on: {
            init: (e) => {
              this.syncActiveVRSlide();
              this.syncVRFrames();
              this.handleVideo(e);
            },
            slideChange: () => {
              if (hasTabs) this.updateTabSlider(thumbnails, swiper);
              this.syncActiveVRSlide();
              this.syncVRFrames();
              this.handleVideo(swiper);
            },
          },
        });

        // Tab 点击切换
        if (hasTabs) {
          this.querySelectorAll('.yg-vr-tab').forEach((tabBtn, index) => {
            tabBtn.addEventListener('click', () => swiper.slideTo(index));
          });
        }
      }

      updateTabSlider(thumbnails = null, swiper = null) {
        const tabSlider = this.querySelector('.yg-vr-tabs .yg-tab-slider');
        const activeTab =
          this.querySelector('.yg-vr-tab.swiper-slide-thumb-active') ||
          this.querySelector('.yg-vr-tab[aria-selected="true"]');
        if (!tabSlider || !activeTab) return;

        tabSlider.style.setProperty('--active-left', activeTab.offsetLeft + 'px');
        tabSlider.style.setProperty('--active-width', activeTab.offsetWidth + 'px');

        if (thumbnails && swiper) thumbnails.slideToLoop(swiper.realIndex);
      }

      initVRButton() {
        this.querySelectorAll('.yg-vr-view-btn').forEach((btn) => {
          btn.addEventListener('click', () => {
            const slide = btn.closest('.yg-vr-slide');
            this.vrActivated = true;
            this.activateVRSlide(slide);
          });
        });
      }
    }

    if (!customElements.get('yg-vr-showcase')) {
      customElements.define('yg-vr-showcase', YGVRShowcase);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
